import { render, staticRenderFns } from "./PdfViewerMobile.vue?vue&type=template&id=b7d60e60&"
import script from "./PdfViewerMobile.vue?vue&type=script&lang=js&"
export * from "./PdfViewerMobile.vue?vue&type=script&lang=js&"
import style0 from "./PdfViewerMobile.vue?vue&type=style&index=0&id=b7d60e60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports